import { useEffect } from 'react';
import { getAuthToken, getRefreshToken } from '../auth';
import { isTokenValid } from '../utils';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import { useModal } from '../contexts';

function ReloadModal() {
  const { t } = useTranslation();
  const { closeModal } = useModal();

  const authToken = getAuthToken();
  const refreshToken = getRefreshToken();

  useEffect(() => {
    if (isTokenValid(authToken) && isTokenValid(refreshToken))
      closeModal();

  }, [closeModal, authToken, refreshToken]);

  return (
    <Modal
      preventClose={true}
      title={t("Session Expired")}
      subtitle={t("Reload this page to continue using Portant")}
      primaryButtonProps={{ text: t("Reload"), onClick: () => window.location.reload() }}
      size='sm'
    />
  );
}

export default ReloadModal;
